<template>
    <div>
        <q-table
            ref="table"
            :data="materials"
            :columns="columns_materials"
            row-key="id"
            :pagination.sync="pagination_materials"
            @request="requestMaterials"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            class="q-mt-lg"
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props">
                    <q-td key="title" :props="props">
                        {{ props.row.title }}
                    </q-td>

                    <q-td key="hits" :props="props">
                        {{ props.row.hits }}
                    </q-td>

                    <q-td key="extension" :props="props">
                        {{ props.row.extension }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width text-center">
                            {{ $t(getTextStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>

                    <q-td auto-width key="actions" :props="props">
                        <q-btn flat round color="secondary" icon="fas fa-users" @click="showMaterialUsers(props.row)" >
                            <q-tooltip>
                                {{ $t('participants_report_tooltip') }}
                            </q-tooltip>
                        </q-btn>
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-modal v-model="show_material_users" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_material_users = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ material.title }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout">
                    <q-table
                        ref="table"
                        :data="users"
                        :columns="columns_users"
                        row-key="user_id"
                        :pagination.sync="pagination_users"
                        @request="requestUserMaterial"
                        :loading="loading"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[5,10,50,100]"
                        binary-state-sort
                        class="q-ma-md"
                        >

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <template slot="body" slot-scope="props">
                            <q-tr :props="props">
                                <q-td key="user_full_name" :props="props">
                                    {{ props.row.user_full_name }}
                                </q-td>

                                <q-td key="user_email" :props="props">
                                    {{ props.row.user_email }}
                                </q-td>

                                <q-td key="user_profile" :props="props">
                                    {{ props.row.user_profile }}
                                </q-td>

                                <q-td key="download_date" :props="props">
                                    {{ fDate(props.row.download_date) }}
                                </q-td>
                            </q-tr>
                        </template>
                    </q-table>
                </div>
            </q-modal-layout>
        </q-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
    name: 'AdminPresentialReportSupportMaterial',

    props: ['load', 'id'],

    data() {
        return {
            pagination_materials: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            pagination_users: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: null,
                descending: false,
                sortBy: null
            },
            columns_materials: [
                {
                    name: 'title',
                    required: true,
                    label: 'title',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'hits',
                    required: true,
                    label: 'downloads',
                    align: 'left',
                    field: 'hits',
                    sortable: true,
                },
                {
                    name: 'extension',
                    required: true,
                    label: 'extension',
                    align: 'left',
                    field: 'extension',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'left',
                    field: 'actions',
                    sortable: false,
                }
            ],
            columns_users: [
                {
                    name: 'user_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'user_full_name',
                    sortable: true,
                },
                {
                    name: 'user_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'user_email',
                    sortable: true,
                },
                {
                    name: 'user_profile',
                    required: true,
                    label: 'profile',
                    align: 'left',
                    field: 'user_profile',
                    sortable: true,
                },
                {
                    name: 'download_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'download_date',
                    sortable: false,
                }
            ],
            materials: [],
            users: [],
            material: {},
            show_material_users: false,
            loading: false,
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    methods: {
        requestMaterials({ pagination }) {
            this.loading = true
            this.pagination_materials = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination_materials.rowsPerPage,
                "page": this.pagination_materials.page,
                "ordering": order_by
            }

            this.savePaginationMaterials()

            // this.$axios.get(`/presential/presential_events/${this.id}/support_materials/?${this.$qs.stringify(data)}`, this.getHeader)
            this.$axios.get(`/presential/presential_events/${this.id}/support_materials/`, this.getHeader)
            .then(response => {
                this.pagination_materials.rowsNumber = response.data.length ? response.data.length : 0

                this.materials = response.data.map(e => {
                    return { ...e, actions: e.id }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        requestUserMaterial({ pagination }) {
            this.loading = true
            this.pagination_users = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.pagination_users.rowsPerPage,
                "page": this.pagination_users.page,
                "ordering": order_by
            }

            this.savePaginationUsers()

            // this.$axios.get(`/admin_group_trainings/group_trainings/${this.id}/group_training_material_user_downloads/${this.material.id}/?${this.$qs.stringify(data)}`, this.getHeader)
            this.$axios.get(`/presential/presential_events/${this.id}/reports/presential_event_material_user_downloads/${this.material.id}/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.pagination_users.rowsNumber = response.data.count

                this.users = response.data.results.map(e => {
                    return { ...e }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showMaterialUsers(row) {
            this.material = row
            this.show_material_users = true

            this.requestUserMaterial({
                pagination: this.pagination_materials
            })
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },

        getTextStatus(status) {
            if (status === 1) return 'published'
            else if (status === 2) return 'unpublished'
        },

        getColorStatus(status) {
            if (status === 1) return 'positive'
            else if (status === 2) return 'negative'
            else return 'tertiary'
        },

        getIconStatus(status) {
            if (status === 1) return 'fas fa-check'
            else if (status === 2) return 'fas fa-times'
            else return 'far fa-clock'
        },

        savePaginationMaterials() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_materials.rowsPerPage])
        },

        savePaginationUsers() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_users.rowsPerPage])
        },

        loadPagination() {
            this.pagination_materials.rowsPerPage = this.num_rows
            this.pagination_users.rowsPerPage = this.num_rows
        }
    },

    watch: {
        load: function() {
            if (this.load) {
                this.requestMaterials({ pagination: this.pagination_materials })
            }
        },

         num_rows: {
            handler: function(newValue) {
                this.loadPagination()
            },
            deep: true
        },
    },

    created() {
        this.loadPagination()

        this.requestMaterials({ pagination: this.pagination_materials })
    }
}
</script>

<style>

</style>
